import { APIGet, APIPost } from './http';
import { IFetchData } from '../_types/post';
import { ISearchResult } from '../_types/search';
import { ICredential, IUser } from '../_types/user';
import { IPolicyObject, PolicyObjectTypeOptions } from '../_types/ewpolicy';


export const GetCredentials = async (user_id: number): Promise<ICredential[]> => {

    let fromAPI: ICredential[] | null = null;
    let toReturn: ICredential[] = [];

    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "auth",
        api_version: "1.0",
        relay_to: `/auth/get_credentials/${user_id}`
    };

    fromAPI = await APIPost<ICredential[] | null>(post);
    if (fromAPI !== null) {
        toReturn = fromAPI;
    }

    return toReturn;

}

export const LogOutAllDevices = async (user_id: number): Promise<boolean> => {

    let fromAPI: boolean | null = false;
    let toReturn: boolean = false;

    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "auth",
        api_version: "1.0",
        user_id: user_id,
        relay_to: `/auth/logout/${user_id}`
    };

    fromAPI = await APIPost<boolean | null>(post);
    if (fromAPI !== null) {
        toReturn = fromAPI;
    }

    return toReturn;

}

export const IssueForgotPasswordEmail = async (user_id: number): Promise<ICredential | null> => {


        let postObj = { 
            user_id: user_id,
            send: true
            
        };
    
    
        let post: IFetchData = {
            authorize: true,
            method:"POST",
            refresh: false,
            service: "ewapi",
            relay_to: "/auth/forgotpassword/email",
            ...postObj
        };
        
        let result: ICredential | null = null;
    
        try {
           
            result = await APIPost<ICredential | null>(post);
            
        } catch (ex) {
            //do nothing
        }
        // let result: ISearchResult[] = [
        //     {
        //         key: "1", value: "Test wash abc"
        //     }, {
        //         key: "2", value: "Test wash def"
        //     }
        // ];
    
        // return Promise.resolve(result);
        
        return result;
    
    

}

export const DeleteCredential = async (cred: ICredential): Promise<boolean> => {

    let fromAPI: boolean | null = false;
    let toReturn: boolean = false;

    let post: IFetchData = {
        authorize: true,
        method: "GET",
        refresh: false,
        service: "auth",
        api_version: "1.0",
        relay_to: `/auth/delete_credential`,
        credential_uuid: cred.uuid,
        user_id: { _id: cred.user_uuid, partition: cred.pool }
        
    };

    fromAPI = await APIPost<boolean | null>(post);
    if (fromAPI !== null) {
        toReturn = fromAPI;
    }

    return toReturn;

}

export const GetUser = async (user_id: number): Promise<IUser | null> => {


    let toReturn: IUser | null = null;

    let request: IFetchData = {
        
        relay_to: `/user/getapiuser/${user_id}`,
        method: "GET",
        service: "ewapi",
        authorize: true,
        refresh: true
    };

    toReturn = await APIGet(request);
    

    if (toReturn) {

        (toReturn as IPolicyObject).policies = [];
        (toReturn as IPolicyObject).objectType = PolicyObjectTypeOptions.user;

        toReturn.authorized = false;
        toReturn.fromCookie = false;
    } else {
        toReturn = { fromCookie: false, authorized: false, objectType: PolicyObjectTypeOptions.user };
    }
    
    
    return toReturn;

}

export const SearchUsers = async (query: string, includeDeleted: boolean, abort: AbortController, locationId?: number | null): Promise<ISearchResult[] | null> => {


    let postObj = { 
        query: query,
        includeDeleted: includeDeleted,
        location_id: (locationId) ? locationId : null
    };


    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/user/searchusers",
        ...postObj
    };
    
    let result: ISearchResult[] | null = [];

    try {
        if (query.length >= 3) {
            result = await APIPost<ISearchResult[] | null>(post, abort);
        }
    } catch (ex) {
        //do nothing
    }
    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    
    return result;

}